var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgSetting = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 2.915C8.5 1.857 9.357 1 10.415 1h3.17c1.057 0 1.915.857 1.915 1.915 0 1.344 1.454 2.183 2.617 1.511a1.915 1.915 0 0 1 2.616.701l1.585 2.746a1.915 1.915 0 0 1-.7 2.616c-1.164.671-1.164 2.35 0 3.022.915.53 1.23 1.7.7 2.616l-1.585 2.746a1.915 1.915 0 0 1-2.616.7c-1.163-.671-2.617.168-2.617 1.512A1.915 1.915 0 0 1 13.585 23h-3.17A1.915 1.915 0 0 1 8.5 21.085c0-1.344-1.455-2.183-2.618-1.511a1.915 1.915 0 0 1-2.616-.701L1.68 16.127a1.915 1.915 0 0 1 .7-2.616c1.164-.671 1.164-2.35 0-3.022a1.915 1.915 0 0 1-.7-2.616l1.585-2.746a1.915 1.915 0 0 1 2.616-.7C7.045 5.097 8.5 4.258 8.5 2.914ZM10.499 3c-.06 2.805-3.084 4.55-5.543 3.2L3.455 8.8c2.4 1.454 2.4 4.946 0 6.4l1.5 2.6c2.46-1.35 5.484.395 5.544 3.2H13.5c.06-2.805 3.083-4.55 5.542-3.2l1.501-2.6c-2.4-1.454-2.4-4.946 0-6.4l-1.5-2.6C16.583 7.55 13.56 5.805 13.5 3h-3.002Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    clipRule: "evenodd"
  })));
});
SvgSetting.displayName = "SvgSetting";
export default SvgSetting;